<template>
  <div class="formmsg" v-if="formmsg">
    <!-- 选择报名表单弹窗 -->
    <div class="pagePopMask pFull" @click.self="closePop"></div>
    <div class="pagePop pCenter">
      <div class="w pad60">
        <div class="tit fnt_24 relative">{{ globalDataArray.siteTemplateLanguage.apply_join }}</div>
        <div class="tips">{{ globalDataArray.siteTemplateLanguage.please_write_info }} </div>
        <div class="cont">
          <div class="stform">
            <a-form :form="form" :model="data">
              <a-row :gutter="18">
                <div v-for="item in teamMemberList" :key="item.fieldSort + 'n'" v-if="item.isShow === '1' || item.isDoubleCheck">
                  <a-col :xs="24" :sm="24" :md="item.isStandalone === '0' ? 12 : 24" :lg="item.isStandalone === '0' ? 12 : 24" :xl="item.isStandalone === '0' ? 12 : 24">
                    <a-form-item
                      :label="item.fieldName" :extra="item.prompt && item.prompt[0] ? item.prompt[0] : ''"
                    >
                      <!--              下拉框-->
                      <a-select
                        v-if="item.fieldCode === 'company' && item.isDoubleCheck"
                        show-search
                        allow-clear
                        :filter-option="false"
                        placeholder="请输入学校"
                        :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                        v-decorator="[`data.${item.fieldCode}`, { rules: [{ required: true, message: '请选择' + item.fieldName + '!' }] }]"
                        @search="searchCollege"
                      >
                        <a-select-option v-for="fi in filterdCollegeList" :key="fi.identificationCode" :value="fi.name">
                          {{ fi.name }}
                        </a-select-option>
                      </a-select>
                      <a-select
                        :label-in-value="true"
                        placeholder="请选择" v-else-if="item.fieldCode === 'countryCode'" @change="handleProvinceChange"
                        v-decorator="[`data.${item.fieldCode}`, { rules: [{ required: item.verificationType, message: '请选择' + item.fieldName + '!' }] }]"
                      >
                        <a-select-option :value="po.parentId" v-for="po in item.list" :key="po.parentId">
                          {{ po.title }}
                        </a-select-option>
                      </a-select>
                      <a-select
                        :label-in-value="true"
                        placeholder="请选择" v-else-if="item.fieldCode === 'cityCode'"
                        v-decorator="[`data.${item.fieldCode}`, { rules: [{ required: item.verificationType, message: '请选择' + item.fieldName + '!' }] }]"
                      >
                        <a-select-option :value="po.itemValue" v-for="po in item.list" :key="po.itemValue">
                          {{ po.itemText }}
                        </a-select-option>
                      </a-select>
                      <a-select
                        placeholder="请选择" v-else-if="item.fieldType === 'select'"
                        v-decorator="[`data.${item.fieldCode}`, { rules: [{ required: item.verificationType, message: '请选择' + item.fieldName + '!' }] }]"
                      >
                        <a-select-option :value="po.itemValue" v-for="po in item.list" :key="po.itemValue">
                          {{ po.itemText }}
                        </a-select-option>
                      </a-select>
                      <!--              普通输入框-->
                      <a-input
                        v-else-if="item.fieldType === 'text' && item.verificationType === 'email'"
                        v-decorator="[`data.${item.fieldCode}`, { rules: [
                          { validator: validateNumber, trigger: 'blur' },
                          { required: item.verificationType , message: '请输入' + item.fieldName + '!' }] }]"
                      />
                      <a-input
                        v-else-if="item.fieldType === 'text' && item.verificationType === 'idCard'"
                        v-decorator="[`data.${item.fieldCode}`, { rules: [
                          { validator: validateID, trigger: 'blur' },
                          { required: item.verificationType , message: '请输入' + item.fieldName + '!' }] }]"
                      />
                      <a-input
                        v-else-if="item.fieldType === 'text' && item.verificationType === 'phone'"
                        v-decorator="[`data.${item.fieldCode}`, { rules: [
                          { pattern: /^[0-9-+]+$/, message: '请输入正确的手机号格式' },
                          { validator: verify.bootTwo ? (rule, value, callback) => validateTwoFactor(rule, value, callback, 'data.userName', 'data.userPhone') : undefined, trigger: 'blur' },
                          { required: item.verificationType , message: '请输入' + item.fieldName + '!' }] }]"
                      />
                      <a-input
                        v-else-if="item.fieldType === 'text'"
                        v-decorator="[`data.${item.fieldCode}`, { rules: [{ required: item.verificationType , message: '请输入' + item.fieldName + '!' }] }]"
                      />
                      <!--              普通单选框-->
                      <a-radio-group
                        v-else-if="item.fieldType === 'radio' && item.fieldCode === 'companyType'"
                        @change="onChangeCompany"
                        v-decorator="[`data.${item.fieldCode}`, { rules: [{ required: item.verificationType , message: '请选择' + item.fieldName + '!' }] }]"
                      >
                        <a-radio :value="ca.itemValue" v-for="(ca,index) in item.list" :key="ca.itemValue">
                          {{ ca.itemText }}
                        </a-radio>
                      </a-radio-group>
                      <a-radio-group
                        v-else-if="item.fieldType === 'radio'"
                        v-decorator="[`data.${item.fieldCode}`, { rules: [{ required: item.verificationType , message: '请选择' + item.fieldName + '!' }] }]"
                      >
                        <a-radio :value="ca.itemValue" v-for="(ca,index) in item.list" :key="ca.itemValue">
                          {{ ca.itemText }}
                        </a-radio>
                      </a-radio-group>
                      <!--              文件上传-->
                      <a-upload
                        v-else-if="item.fieldType === 'upload'"
                        v-decorator="[`data.${item.fieldCode}`,
                                      {
                                        getValueFromEvent: normFile,
                                        rules: [{ required: item.verificationType, message: '文件上传' }]
                                      }
                        ]"
                        name="file"
                        accept=".zip,.rar,.7z"
                        :file-list="item.fileList"
                        :remove="(file) => removeFiles1(file, item)"
                        :before-upload="(file) => beforeUpload1(file, item)"
                        :custom-request="customUpload"
                      >
                        <a-button :disabled="uploading" class="my-5">文件上传</a-button>
                      </a-upload>
                    </a-form-item>
                  </a-col>
                </div>
              </a-row>

              <!-- 国内成人 -->
              <template v-if="curInfoArray.currentLanguge=='zh_CN'&&curInfoArray.currentLanguge!=''&&curInfoArray.templateId=='01'">
                <div class="item">
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.name_text">
                    <a-input
                      v-decorator="['data.userName', {rules:[{required:true,message:globalDataArray.siteTemplateLanguage.enter_name_text}]}]"
                    />
                  </a-form-item>
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_phone">
                    <a-input
                      v-decorator="['data.userPhone',{rules:[{required:true,message:globalDataArray.siteTemplateLanguage.enter_member_tel}]}]"
                    />
                  </a-form-item>
                </div>

                <div class="item">
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_email">
                    <a-input
                      v-decorator="['data.userMail',{ rules:[{ validator: validateNumber, trigger: 'blur'},{required:true,message:globalDataArray.siteTemplateLanguage.person_please_form_user_email}]}]"
                    />
                  </a-form-item>
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_company_type">
                    <a-radio-group @change="onChangeCompanyType" v-decorator="['data.companyType', { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_company_type }] }]">
                      <a-radio :style="radioStyle" v-for="(item,index) in companyList" :value="item.itemValue" :key="index">{{ item.itemText }}</a-radio>
                    </a-radio-group>
                  </a-form-item>
                </div>

                <a-form-item
                  :label="globalDataArray.siteTemplateLanguage.team_user_company_name"
                  v-if="form.getFieldValue('data.companyType') && (curInfoArray.currentLanguge == 'zh_CN' || curInfoArray.currentLanguge == '')"
                >
                  <a-select
                    show-search
                    allow-clear
                    :filter-option="false"
                    :placeholder="globalDataArray.siteTemplateLanguage.search_keywords"
                    :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                    v-decorator="['data.company', { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_company_name }] }]"
                    @search="searchCollege"
                    v-if="form.getFieldValue('data.companyType') === '02'"
                  >
                    <a-select-option v-for="item in filterdCollegeList" :key="item.identificationCode" :value="item.name">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                  <a-input
                    v-decorator="['data.company', { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_company_name }] }]"
                    v-else
                  />
                </a-form-item>

                <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_job_type">
                  <a-radio-group @change="onChange" v-decorator="['data.jobType']">
                    <a-radio :style="radioStyle" v-for="(item,index) in jobList" :value="item.itemValue" :key="index">{{ item.itemText }}</a-radio>
                  </a-radio-group>
                </a-form-item>

                <div class="item">
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.person_form_province">
                    <a-select @change="handleProvinceChange" :label-in-value="true" v-decorator="['data.countryCode', { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_province }] }]">
                      <a-select-option v-for="item in provinceList" :key="item.parentId">
                        {{ item.title }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_city">
                    <a-select :label-in-value="true" v-decorator="['data.cityCode', { rules: [{ required: false, message: globalDataArray.siteTemplateLanguage.person_please_form_city }] }]">
                      <a-select-option v-for="item in cityList" :key="item.id">
                        {{ item.title }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </div>
              </template>

              <!-- 国内青少年 -->
              <template v-if="curInfoArray.currentLanguge=='zh_CN'&&curInfoArray.currentLanguge!=''&&curInfoArray.templateId=='02'">
                <div class="item">
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.name_text">
                    <a-input
                      v-decorator="['data.userName', {rules:[{required:true,message:globalDataArray.siteTemplateLanguage.enter_name_text}]}]"
                    />
                  </a-form-item>
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.team_member_school">
                    <a-input
                      v-decorator="['data.company',{ rules:[{required:true,message:globalDataArray.siteTemplateLanguage.person_please_form_school_name}]}]"
                    />
                  </a-form-item>
                </div>

                <div class="item">
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.person_form_province">
                    <a-select @change="handleProvinceChange" :label-in-value="true" v-decorator="['data.countryCode', { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_province }] }]">
                      <a-select-option v-for="item in provinceList" :key="item.parentId">
                        {{ item.title }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_city">
                    <a-select :label-in-value="true" v-decorator="['data.cityCode', { rules: [{ required: false, message: globalDataArray.siteTemplateLanguage.person_please_form_city }] }]">
                      <a-select-option v-for="item in cityList" :key="item.id">
                        {{ item.title }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </div>
              </template>

              <!-- 国外成年 -->
              <template v-if="curInfoArray.currentLanguge=='en_US'&&curInfoArray.currentLanguge!=''&&curInfoArray.templateId=='01'">
                <div class="item">
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.name_text">
                    <a-input
                      v-decorator="['data.userName', {rules:[{required:true,message:globalDataArray.siteTemplateLanguage.enter_name_text}]}]"
                    />
                  </a-form-item>
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_email">
                    <a-input
                      v-decorator="['data.userMail',{ rules:[{ validator: validateNumber, trigger: 'blur'},{required:true,message:globalDataArray.siteTemplateLanguage.person_please_form_user_email}]}]"
                    />
                  </a-form-item>
                </div>

                <div class="item">
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.person_form_country">
                    <a-select @change="handleProvinceChange" :label-in-value="true" v-decorator="['data.countryCode', { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_country }] }]">
                      <a-select-option v-for="item in provinceList" :key="item.parentId">
                        {{ item.title }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_city">
                    <a-select :label-in-value="true" v-decorator="['data.cityCode', { rules: [{ required: false }] }]">
                      <a-select-option v-for="item in cityList" :key="item.id">
                        {{ item.title }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </div>
              </template>

              <!-- 国外青少年 -->
              <template v-if="curInfoArray.currentLanguge=='en_US'&&curInfoArray.currentLanguge!=''&&curInfoArray.templateId=='02'">
                <div class="item">
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.name_text">
                    <a-input
                      v-decorator="['data.userName', {rules:[{required:true,message:globalDataArray.siteTemplateLanguage.enter_name_text}]}]"
                    />
                  </a-form-item>
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.team_member_school">
                    <a-input
                      v-decorator="['data.company',{ rules:[{required:true,message:globalDataArray.siteTemplateLanguage.person_please_form_school_name}]}]"
                    />
                  </a-form-item>
                </div>

                <div class="item">
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.person_form_country">
                    <a-select @change="handleProvinceChange" :label-in-value="true" v-decorator="['data.countryCode', { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_country }] }]">
                      <a-select-option v-for="item in provinceList" :key="item.parentId">
                        {{ item.title }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_city">
                    <a-select :label-in-value="true" v-decorator="['data.cityCode', { rules: [{ required: false }] }]">
                      <a-select-option v-for="item in cityList" :key="item.id">
                        {{ item.title }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </div>
              </template>
            </a-form>
          </div>
        </div>

        <div class="btnBox fnt_18">
          <div class="btn btn1" @click="btnClick('1')">{{ globalDataArray.siteTemplateLanguage.right_away_sign }}</div>
          <div class="btn btn2" @click="btnClick('2')">{{ globalDataArray.siteTemplateLanguage.cancel }}</div>
        </div>

        <div class="close" @click.self="closePop"></div>
      </div>
    </div>

    <div class="pagePopMask pFull" v-if="showXuzhi" @click="targetXuzhi"></div>
    <div class="pagePop pCenter" v-if="showXuzhi">
      <div class="w pad60">
        <div class="tit fnt_32">{{ xuzhiCont.title }}</div>

        <div class="cont" v-html="xuzhiCont.content">
        </div>
        <div class="btnBox fnt_18">
          <div class="btn btn1" @click="targetXuzhi">{{ globalDataArray.siteTemplateLanguage.verify }}</div>
        </div>
        <div class="close" @click="targetXuzhi"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { message } from 'ant-design-vue'
import { getCompetitionDict, getProvinceList, getCityList, getArticle, getArticleDetail } from '@/api/api'
import Cookies from 'js-cookie'
import { joinTeam, getCollegeList, queryByParentId, uploadFile, boolAuth, verifyTwo } from '@/api/saiti'

export default {
  name: 'Formmsg',
  props: {
    formmsg: {
      type: Boolean,
      default: false
    },
    curInfoArray: {
      type: Object,
      default: () => ({})
    },
    teamArray: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      data: [{
        teamName: '',
        teamType: '',
        leaderName: '',
        userPhone: '',
        userMail: '',
        companyType: '',
        company: '',
        jobType: '',
        countryCode: '',
        countryName: '',
        cityCode: '',
        cityName: '',
        cityList: [],
        provinceList: {}, // 公共的省或国家
        companyList: {}, // 公共的单位类型
        jobList: {}, // 公共的职业类型
        teamList: {} // 公共的团队类型
      }],
      uploading: false,

      form: this.$form.createForm(this, { name: 'dynamic_rule' }),

      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },

      provinceList: [],

      cityList: [],

      defaultArea: [],
      xuzhiCont: '',
      showXuzhi: false,
      verify: false,
      subblur: true, // 避免重复提交

      collegeList: [],
      filterdCollegeList: [],
      showList: [], // 队员固定列表
      teamMemberList: [], // 队员固定列表
      allList: [], // 字段所有信息
      dictCodeArray: [] // 列表字典值
    }
  },
  watch: {
    formmsg: {
      immediate: true,
      handler(val) {
        if (val) {
          this.subblur = true
          this.init()
        }
      }
    }
  },
  mounted() {
    this.init()
    this.getCollegeList()
  },
  methods: {
    async init() {
      /*      // console.log(this.curInfoArray,'formmsg')
      const that = this
      const params = 'dictCode=competition_signup_team_type,competition_signup_job_type,competition_signup_company_type'
      getCompetitionDict(params).then(res => {
        if (res.success) {
          // console.log(res)
          res.result.forEach((item, index) => {
            if (item.dictCode == 'competition_signup_company_type') { // 单位类型
              that.companyList = item.list // 公共的单位类型
            }
            if (item.dictCode == 'competition_signup_job_type') { // 职业类型
              that.jobList = item.list // 公共的职业类型
            }
            if (item.dictCode == 'competition_signup_team_type') { // 团队类型
              // that.teamList=item.list        //公共的团队类型

              const teamList = item.list
              // 两个说明
              getArticle('type=5,6').then(res => {
                if (res.success) {
                  const tipsMsg = res.result

                  teamList.forEach((item, index) => {
                    if (item.itemValue == '01') { // 个人
                      tipsMsg.forEach((e, i) => {
                        if (e.type == '5') {
                          item['tipsmsg'] = e.content
                        }
                      })
                    }

                    if (item.itemValue == '02') { // 公司
                      tipsMsg.forEach((e, i) => {
                        if (e.type == '6') {
                          item['tipsmsg'] = e.content
                        }
                      })
                    }
                  })

                  that.teamList = teamList
                }
              })
            }
          })
        }
      })*/

      getProvinceList().then(res => {
        if (res.success) {
          this.provinceList = res.result // 省或国家列表
        }
      })

      this.findAllColunm()
      // 获取是否开启验证
      const params = 'language=' + this.globalDataArray.siteInfo.language + '&competitionId=' + this.curInfoArray.competitionId
      const boolAuthRes = await boolAuth(params)
      if (boolAuthRes.success) {
        this.verify = boolAuthRes.result
      }
    },

    findAllColunm() {
      const paTemp = 'language=' + this.globalDataArray.siteInfo.language + '&templateId=' + this.curInfoArray.templateId
      queryByParentId(paTemp).then(res => {
        if (res.success) {
          // 全部字段信息
          this.allList = JSON.parse(res.result.fieldJson)
          // 获取所有字典值
          this.allList.forEach(item => {
            // 检查 item 中是否有 dictCode 属性
            if (item.dictCode) {
              // 将 dictCode 数据添加到数组中
              this.dictCodeArray.push(item.dictCode)
            }
          })
          this.findDictCode()
        }
      })
    },

    // 给字段值绑定字典列表
    findDictCode() {
      const param = 'dictCode=' + this.dictCodeArray.join(',')
      getCompetitionDict(param).then(res => {
        if (res.success) {
          const dictCodeList = res.result
          this.allList = this.allList.map(showItem => {
            const dictItem = dictCodeList.find(dictItem => dictItem.dictCode === showItem.dictCode)
            if (dictItem) {
              showItem.list = dictItem.list
            }
            if (showItem.fieldType === 'upload') {
              showItem.fileList = []
            }
            if (showItem.fieldCode === 'countryCode') {
              showItem.list = this.provinceList
              console.log(showItem, this.provinceList)
            }
            return showItem
          })
          this.showList = this.allList.filter(item => item.isTeam === 0)
          const teamMemberListCopy = JSON.parse(JSON.stringify(this.showList))
          teamMemberListCopy.forEach(item => {
            if (item.fieldCode === 'leaderName') {
              item.fieldName = '队员'
              item.fieldCode = 'userName'
            }
          })
          this.teamMemberList = teamMemberListCopy
          console.log(this.showList, 'mmmmmm')
          console.log(this.teamMemberList, 'zzzzz')
        }
      })
    },

    // 二要素验证
    validateTwoFactor(rule, value, callback, name, phone) {
      if (!value) {
        callback()
        return
      }
      const params = {
        name: this.form.getFieldValue(name),
        phone: this.form.getFieldValue(phone),
        competitionId: this.curInfoArray.competitionId
      }

      // 这里你可以添加你的二要素验证逻辑
      verifyTwo(params).then(res => {
        if (res.success) {
          const isValid = res.result
          callback()
        } else {
          callback(new Error('手机号未通过二要素验证'))
        }
      })
    },

    onChange(e) {
      // console.log(e.target.value)
    },

    // 省市联动
    handleProvinceChange(e) {
      console.log(e)
      const that = this
      const params = 'pid=' + e.key + '&language=' + this.globalDataArray.siteInfo.language
      getCityList(params).then(res => {
        if (res.success) {
          that.teamMemberList.forEach(item => {
            if (item.fieldCode === 'cityCode') {
              res.result.forEach(ca => {
                ca.itemValue = ca.id
                ca.itemText = ca.title
              })
              item.list = res.result
            }
          })
          setTimeout(() => {
            // 选择后清空二级
            this.form.setFieldsValue({
              'data.cityCode': ''
            })
          })
        }
      })
    },

    btnClick(res) {
      // console.log(this.curInfoArray,this.teamArray,'formmsg')
      if (res == 1 && this.subblur) {
        this.form.validateFields((err, val) => {
          if (!err) {
            if (val.data.countryCode) {
              const countryKL = val.data.countryCode
              if (countryKL.key) {
                val.data['countryCode'] = countryKL.key
              }
              if (countryKL.label) {
                val.data['countryName'] = countryKL.label
              }
            }

            if (val.data.cityCode) {
              const cityKL = val.data.cityCode
              if (cityKL.key) {
                val.data['cityCode'] = cityKL.key
              }
              if (cityKL.label) {
                val.data['cityName'] = cityKL.label
              }
            } else {
              val.data['cityCode'] = ''
              val.data['cityName'] = ''
            }
            console.log(this.curInfoArray, 'ddddddd')
            const sigupJson = JSON.stringify(val.data)
            console.log(val.data, 'val.data')
            console.log(sigupJson, 'sigupJson')

            // 排列数据
            const params = {
              'categoryId': this.curInfoArray.categoryId,
              'parentId': this.teamArray.parentId,
              'competitionId': this.curInfoArray.competitionId,
              'teamName': this.teamArray.teamName,
              'teamType': this.teamArray.teamType,
              'teamNo': this.teamArray.teamNo,
              'nation': this.teamArray.nation,
              'templateId': this.curInfoArray.templateId,
              'userName': val.data.userName,
              'userPhone': val.data.userPhone,
              'userMail': val.data.userMail,
              'countryCode': val.data.countryCode,
              'countryName': val.data.countryName,
              'cityCode': val.data.cityCode,
              'cityName': val.data.cityName,
              'company': val.data.company,
              'companyType': val.data.companyType,
              'jobType': val.data.jobType,
              'isCaptain': 0,
              'leaderName': this.teamArray.leaderName,
              'groupId': this.teamArray.groupId,
              'grade': this.teamArray.grade,
              'currentLanguge': this.teamArray.currentLanguge,
              'teams': this.teamArray.teams,
              'zoneId': this.teamArray.zoneId,
              'teamsUsers': this.teamArray.teamsUsers,
              ...val.data
            }
            params.sigupJson = JSON.stringify(params)

            // 如果青少年未填,获取账号的手机和邮箱
            if (val.data.userPhone == '' || val.data.userPhone == null || val.data.userPhone == undefined) {
              params['userPhone'] = JSON.parse(Cookies.get('saiti_access_info')).phone
            }
            if (val.data.userMail == '' || val.data.userMail == null || val.data.userMail == undefined) {
              params['userMail'] = JSON.parse(Cookies.get('saiti_access_info')).email
            }

            const sourceParam = (window.localStorage.getItem('competition-utm-source') || '').trim()

            if (sourceParam) {
              params['inviteCode'] = sourceParam
            }

            console.log('formmsg', params)
            // console.log(JSON.parse(Cookies.get("saiti_access_info")))

            joinTeam(params).then(res => {
              if (res.success) {
                this.subblur = true
                message.success(res.result)
                // 自定义事件，把res传给父组件,发射事件
                this.$emit('itemclick', 1) // itemclick  为事件名
                this.$emit('update:formmsg', false)
              } else {
                if (res.code == '403') {
                  message.error(res.message)
                }
              }
            })
          }
        })
      } else {
        this.$emit('itemclick', 2)
        this.$emit('update:formmsg', false)
      }
    },

    closePop() {
      this.$emit('itemclick', 2)
      this.$emit('update:formmsg', false)
    },
    targetXuzhi() {
      this.showXuzhi = !this.showXuzhi
      if (this.showXuzhi && this.xuzhiCont == '') {
        const params = 'id=1705132838718054401'
        getArticleDetail(params).then(res => {
          if (res.success) {
            this.xuzhiCont = res.result
          }
        })
      }
    },
    validateNumber(rule, value, callback) {
      const regMail = new RegExp('^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}(\.[a-zA-Z]{2,6})?)$')
      if (value != '' && value != undefined && !regMail.test(value)) {
        callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
      } else {
        callback()
      }
    },

    async getCollegeList() {
      const { success, result, message } = await getCollegeList()

      if (success) {
        this.collegeList = result
      }
    },

    searchCollege(value) {
      if (!value) {
        return
      }

      this.filterdCollegeList = this.collegeList.filter(item => {
        if (item.name.indexOf(value) > -1) {
          return true
        }
        return false
      })
    },

    onChangeCompanyType() {
      this.form.setFieldsValue({
        'data.company': ''
      })
    },

    // 验证输入的字符串是否符合中国的身份证号码格式。身份证号码可以是15位或18位数字，其中18位的最后一位可以是数字或字母X（大小写均可）
    validateID(rule, value, callback) {
      const regID = new RegExp(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/)
      if (value != '' && value != undefined && !regID.test(value)) {
        callback(new Error('请输入正确的身份证格式 '))
      } else {
        callback()
      }
    },

    normFile(e) {
      return (e && e.fileList?.[0]?.response) ?? ''
    },

    // 删除上传文件
    removeFiles1(e, item) {
      item.fileList = []
    },

    beforeUpload1(file, item) {
      if (item.fileList.length > 0) {
        message.error(this.globalDataArray.siteTemplateLanguage.only_upload_one)
        return false
      }
      if (!/\.(?:zip|rar|7z)$/.test(file.name)) {
        message.error(this.globalDataArray.siteTemplateLanguage.file_format_error)

        return false
      }
      if (file.size > 1024 * 1024 * 10) {
        message.error(this.globalDataArray.siteTemplateLanguage.file_size_error)

        return false
      }
      item.fileList.push(file)
      return true
    },

    async customUpload(e) {
      const formData = new FormData()

      formData.append('file', e.file)

      this.uploading = true

      const { success, result, message } = await uploadFile(formData)

      this.uploading = false

      if (success) {
        e.onSuccess(result, e)
      }
      else {
        e.onError(message)
      }
    },

    // 切换单位类型
    onChangeCompany(e) {
      const newValue = e.target.value !== '02' ? '1' : '0'
      this.teamMemberList.forEach(item => {
        if (item.fieldCode === 'company') {
          item.isShow = newValue
          item.isDoubleCheck = e.target.value === '02'
        }
      })
    }
  }
}
</script>
